<template>
	<div>Estadísticas</div>
</template>

<script>
export default {
	name: 'statistics',
};
</script>




// WEBPACK FOOTER //
// Statistics.vue?4be1e599